/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentListResponse } from '../../models/agent-list-response';

export interface GetAllAgents$Params {
}

export function getAllAgents(http: HttpClient, rootUrl: string, params?: GetAllAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentListResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllAgents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentListResponse>>;
    })
  );
}

getAllAgents.PATH = '/users/agents';
